import { StaticExample, DynamicExample } from "../../../../src/posts/media-queries-in-javascript/example.tsx";
import * as React from 'react';
export default {
  StaticExample,
  DynamicExample,
  React
};